import { render, staticRenderFns } from "./ClaimsTable.vue?vue&type=template&id=43911f8c&scoped=true&"
import script from "./ClaimsTable.vue?vue&type=script&lang=js&"
export * from "./ClaimsTable.vue?vue&type=script&lang=js&"
import style0 from "./ClaimsTable.vue?vue&type=style&index=0&id=43911f8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43911f8c",
  null
  
)

export default component.exports